import React, { Component } from 'react'
import Layout from 'components/Layout'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { setFlowStepperStep } from 'components/Steps/thunk'
import { Icon } from 'components/Icon'
import ReactTooltip from 'react-tooltip'
import {
	ShipmentBlock,
	ShipmentRadio,
	ShipmentTitle,
	ShipmentCost,
	ShipmentImgHolder,
	ShipmentInfoTooltip,
	ShipmentSetLabels,
	ShipmentInnerBlock,
	ShipmentSetLabelsSelector,
	ShipmentSetLabelsSelectorList,
	ShipmentSetLabelsSelectorListItem,
	ShipmentSetLabelsSelectorDescription,
	ShipmentOptionsCount,
	ShipmentMainBody,
	ShipmentMobileTitle,
	ShipmentOptionsCountNumber,
} from './style'
import { getPartialSteps, addShippingOption } from 'components/Steps/thunk'
import { clearShippingOptions } from 'components/Steps/slices'
import {
	updateContinueState,
	addContinueUrl,
	addBackUrl,
} from 'components/Footer/thunk'
import config from 'configs/config'
import _ from 'lodash'
import { Loader } from 'components/Loader'
import { bindActionCreators, compose } from 'redux'
import StepsAnimation from 'components/StepsAnimation'
import { ShippingLoader } from 'components/Loader/components/ShippingLoader'
import { formatPrice } from 'utils/common'
import { PopupWindow } from 'components/Modal'
import { PopupContent } from '../../components/Modal/style'

const isShipmentOptionHandled = (shippingOptions) => {
	let isShipmentOptionHandled = false

	shippingOptions.forEach((option) => {
		if (option.isSelected) {
			isShipmentOptionHandled = true
		}
	})

	return isShipmentOptionHandled
}

class Shipping extends Component {
	constructor() {
		super()
		this.state = {
			isShippingLabelActive: {
				idx: null,
				status: false,
			},
		}
	}

	componentDidMount() {
		const { shipmentOptions = [] } = this.props
		// set an appropriate flow step
		this.props.setFlowStepperStep('SHIPPING')

		setTimeout(() => {
			let currentOption = _.find(
				shipmentOptions,
				(option) => option.isSelected
			)

			if (!currentOption) {
				currentOption = shipmentOptions[0]
			}

			if (currentOption) {
				this.setShipmentLabelOption({
					id: currentOption.id,
					labels: 1,
				})
			}
		}, 200)
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const {
			partialRequestData = {},
			flowStep,
			nextFlowStep,
			prevFlowStep,
			shipmentOptions = [],
		} = this.props

		if (
			prevProps.flowStep !== flowStep &&
			flowStep === config.flowSteps.SHIPPING
		) {
			this.props.getPartialSteps(partialRequestData)

			// continue button url functionality
			this.props.addContinueUrl(nextFlowStep ? nextFlowStep : 'refund')
		}

		if (
			prevProps.shipmentOptions !== shipmentOptions ||
			prevProps.nextFlowStep !== nextFlowStep ||
			prevProps.prevFlowStep !== prevFlowStep
		) {
			let selectedOption = _.find(
				shipmentOptions,
				(option) => option.isSelected
			)

			if (selectedOption) {
				this.props.getPartialSteps(partialRequestData)
			}

			if (!selectedOption) {
				if (shipmentOptions.length) {
					let currentShipmentOption = shipmentOptions[0]
					this.setShipmentLabelOption({
						id: currentShipmentOption.id,
						labels: 1,
					})
				}
			}

			this.props.addBackUrl(prevFlowStep)
			this.props.updateContinueState(
				isShipmentOptionHandled(shipmentOptions)
			)
		}
	}

	getShipmentSetLabelOptions(
		labelsCount,
		shippingOptionId,
		shippingOptionLabelsAmount,
		isSelected
	) {
		let labels = []

		for (let i = 0; i < labelsCount; i += 1) {
			labels.push(i + 1)
		}

		return (
			<ShipmentSetLabelsSelectorList>
				{labels.map((label) => {
					return (
						<ShipmentSetLabelsSelectorListItem
							key={label}
							onClick={() => {
								this.setShipmentLabelOption({
									id: shippingOptionId,
									labels: label,
								})
								this.hideShippingLabelsAmount(shippingOptionId)
							}}
							isActive={
								isSelected &&
								shippingOptionLabelsAmount === label
							}
						>
							{label}{' '}
							<FormattedMessage
								id={
									label === 1
										? 'shippingSelector.subtitle.label'
										: 'shippingSelector.subtitle.labels'
								}
								defaultMessage='label'
							/>
						</ShipmentSetLabelsSelectorListItem>
					)
				})}
			</ShipmentSetLabelsSelectorList>
		)
	}

	showShippingLabelsAmount = (idx) => {
		if (
			(idx !== this.state.isShippingLabelActive.idx ||
				idx === this.state.isShippingLabelActive.idx) &&
			!this.state.isShippingLabelActive.status
		) {
			this.setState({
				...this.state,
				isShippingLabelActive: {
					idx,
					status: true,
				},
			})
		}
	}
	hideShippingLabelsAmount = (idx) => {
		if (
			idx === this.state.isShippingLabelActive.idx &&
			this.state.isShippingLabelActive.status
		) {
			this.setState({
				...this.state,
				isShippingLabelActive: {
					idx,
					status: false,
				},
			})
		}
	}
	setShipmentLabelOption = (shipmentData) => {
		this.props.addShippingOption({
			...shipmentData,
			labels: shipmentData.labels ? shipmentData.labels : 1,
		})
	}

	render() {
		const { shipmentOptions = [], isLoading, intl } = this.props
		const { isShippingLabelActive } = this.state

		return (
			<Layout>
				<StepsAnimation>
					{!!isLoading && !shipmentOptions.length && (
						<Loader
							isActive={isLoading}
							animation={<ShippingLoader quantity={20} />}
						/>
					)}
					{shipmentOptions?.map((shippingOption) => {
						let {
							id,
							type,
							cost,
							currency,
							imagePath,
							textKey,
							minShipmentLabelCount,
							maxShipmentLabelCount,
							shippingOptionLabelsAmount,
							isSelected = false,
						} = shippingOption

						return (
							<div key={id}>
								<PopupWindow
									open={
										id === isShippingLabelActive.idx &&
										isShippingLabelActive.status
									}
									content={
										<PopupContent>
											<ShipmentSetLabels isVisible={true}>
												<ShipmentSetLabelsSelectorDescription>
													<FormattedMessage
														id='shippingSelector.subtitle.howManyShippingLabelsWillYouNeed'
														default='HOW MANY SHIPPING LABELS DO YOU NEED?'
													/>
												</ShipmentSetLabelsSelectorDescription>
												{isShippingLabelActive && (
													<ShipmentSetLabelsSelector>
														{this.getShipmentSetLabelOptions(
															maxShipmentLabelCount,
															id,
															shippingOptionLabelsAmount,
															isSelected
														)}
													</ShipmentSetLabelsSelector>
												)}
											</ShipmentSetLabels>
										</PopupContent>
									}
									title={
										<FormattedMessage
											id='shippingSelector.title.label.quantity'
											default='Label Quantity'
										/>
									}
									closeOnDocumentClick={true}
									closeOnEscape={false}
									onClose={() => {
										this.hideShippingLabelsAmount(id)
									}}
									popupType={'shipping'}
								/>
								<ShipmentBlock
									isActive={isSelected}
									onClick={() => {
										if (
											maxShipmentLabelCount !==
											minShipmentLabelCount
										) {
											this.showShippingLabelsAmount(id)
										} else {
											this.setShipmentLabelOption({
												id,
												labels: shippingOptionLabelsAmount,
											})
										}
									}}
								>
									<ShipmentMobileTitle>
										<FormattedMessage
											id={`shippingSelector.options.names.${textKey}`}
										/>
									</ShipmentMobileTitle>
									<ShipmentInnerBlock>
										<div>
											<ShipmentRadio
												isActive={isSelected}
											/>
										</div>
										<ShipmentMainBody>
											<div>
												<ShipmentTitle>
													<FormattedMessage
														id={`shippingSelector.options.names.${textKey}`}
													/>
												</ShipmentTitle>
												{shippingOptionLabelsAmount >
												1 ? (
													<ShipmentOptionsCount>
														<FormattedMessage
															id='shippingSelector.subtitle.labels'
															defaultMessage='Labels'
														/>{' '}
														<ShipmentOptionsCountNumber>{`${shippingOptionLabelsAmount}`}</ShipmentOptionsCountNumber>
													</ShipmentOptionsCount>
												) : (
													''
												)}
											</div>
										</ShipmentMainBody>
										<ShipmentImgHolder>
											<img
												src={imagePath}
												alt={textKey}
												width={98}
											/>
										</ShipmentImgHolder>
										<ShipmentInfoTooltip>
											<Icon
												data-for={`shipment_${id}`}
												data-class={
													'shipment_info_icon'
												}
												data-tip={intl.formatMessage({
													id: `shippingSelector.options.info.${type}`,
												})}
												component='infoTooltip'
											/>
											<ReactTooltip
												id={`shipment_${id}`}
												place={'top'}
												type={'dark'}
												effect={'solid'}
												multiline={true}
											/>
										</ShipmentInfoTooltip>
									</ShipmentInnerBlock>
								</ShipmentBlock>
							</div>
						)
					})}
				</StepsAnimation>
			</Layout>
		)
	}
}

function mapStateToProps({ steps }) {
	return {
		...steps,
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			setFlowStepperStep,
			addShippingOption,
			addBackUrl,
			updateContinueState,
			addContinueUrl,
			getPartialSteps,
			clearShippingOptions,
		},
		dispatcher
	)
}

const sippingConnect = connect(mapStateToProps, matchDispatchToProps)

export default compose(sippingConnect, injectIntl)(Shipping)
